import React from 'react'
import { FaSearch } from 'react-icons/fa'

const DashboardSearch = () => {
  return (
    <div>
      <div className="dashboard-search">
        <FaSearch />
        <input type="text" placeholder="Search" name="" id="" />
      </div>
    </div>
  )
}

export default DashboardSearch
